import { Injectable } from '@angular/core';
import { isString, some } from 'lodash-es';
import { forkJoin } from 'rxjs';

import {
  ConfigurationRepository,
} from 'webcommon/legacy-common';
import { UserLoginInfoDto } from 'webcommon/shared';
import { VersionRepository } from 'webcommon/webapi';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  static readonly ajsFactoryName = 'VersionServiceTs';

  constructor(
    private configurationRepository: ConfigurationRepository,
    private versionRepository: VersionRepository,
  ) { }

  async ensureVersions(userLoginInfo: UserLoginInfoDto): Promise<void> {
    if (userLoginInfo.SupportedApiVersions && userLoginInfo.MinClientVersion) {
      return;
    }

    // for legacy purposes, we can call the server
    const data = await forkJoin([
      this.versionRepository.getMinClientVersion(),
      this.versionRepository.getApiVersions(),
    ]).toPromise();

    userLoginInfo.MinClientVersion = data[0];
    userLoginInfo.SupportedApiVersions = data[1];
  }

  checkVersions(apiVersions: string[], minVersion: string) {
    return this.checkApiCompatibility(apiVersions) && this.checkMinClientVersion(minVersion);
  }

  private checkApiCompatibility(apiVersions: string[]) {
      return some(apiVersions, api => {
          return api === this.configurationRepository.SERVER_API_VERSION;
      });
  }

  private checkMinClientVersion(minVersion: string) {
    return this.checkVersionValid(this.configurationRepository.CLIENT_VERSION, minVersion);
  }

  getClientVersion() {
    return this.configurationRepository.CLIENT_VERSION;
  }

  checkVersionValid(currentVersion: string, validVersion: string) {
    if (!isString(validVersion)) {
      throw new Error('validVersion must be a string');
    }

    const validVersionTokens = validVersion.split('.');
    let currentVersionTokens = isString(currentVersion) ? currentVersion.split('.') : undefined;

    if (!currentVersionTokens) {
      currentVersionTokens = validVersionTokens;
    }

    const currentVersionLonger = currentVersionTokens.length >= validVersionTokens.length;
    const len = currentVersionLonger ? validVersionTokens.length : currentVersionTokens.length;
    for (let i = 0; i < len; i++) {
      if (parseInt(currentVersionTokens[i], 10) > parseInt(validVersionTokens[i], 10)) {
        return true;
      }
      else if (parseInt(currentVersionTokens[i], 10) < parseInt(validVersionTokens[i], 10)) {
        return false;
      }
    }

    return currentVersionLonger;
  }
}
